import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HubspotContactUpdateDAO extends BaseDAO<string> {
  constructor(apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.HUBSPOT_CONTACT_PROPERTIES);
  }

  public updateContactProperties(
    email: string,
    userId: number,
    properties: HubspotContactProperties,
  ): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update/' +
      userId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      email: email,
      properties: properties,
    };
    return this.apiHelper.apiCall<boolean>(url, method, null, data, headers);
  }
}

export interface HubspotContactProperties {
  phone?: string;
}
